import onsets from './onsets'
import nuclea from './nuclea'
import codas from './codas'

const presets = {
  onsets,
  nuclea,
  codas,
}

export default presets
